import React from 'react'
import { connect } from 'react-redux'
import { Col, Row } from 'react-bootstrap'
import { getAllBrands } from 'src/store/brand'

const Widget = React.lazy(() => import('src/components/system_wide/stats_widget'), { ssr: false })

const mstp = state => {
  let { id, business_role_priority } = state.userInfo
  let { all_brands: brands } = state.brands

  return {
    business_role_priority,
    user_id: id,
    brands,
  }
}

class Dashboard extends React.Component {
  state = {
    ready: false,
  }

  async componentDidMount() {
    await this.props.dispatch(getAllBrands())
    this.setState({ ready: true })
  }

  render() {
    const { brands, business_role_priority } = this.props
    if (!this.state.ready) return null

    return (
      <div className="card card-body container-fluid flex-fill d-flex flex-column px-0 pb-0 pt-2 mb-0">
        <div className="d-flex flex-column flex-fill">
          {business_role_priority === 4 && (
            <Row>
              <Col xs={12}>
                <Widget type="my_targets_agent" brands={brands} userId={this.props.user_id} />
              </Col>
              <Col xs={12}>
                <Widget type="monthly_targets_by_agent" brands={brands} userId={this.props.user_id} />
              </Col>
            </Row>
          )}
          {business_role_priority !== 4 && (
            <>
              <Row>
                <Col sm={12} md={6}>
                  <Widget type="appointments_by_period" brands={brands} />
                </Col>
                <Col sm={12} md={6}>
                  <Widget type="appointments_by_status" brands={brands} />
                </Col>
              </Row>
              <Row className="mt-3 d-none d-md-block">
                <Col>
                  <Widget type="statistics_per_agent" brands={brands} />
                </Col>
              </Row>
            </>
          )}
        </div>
      </div>
    )
  }
}

export default connect(mstp)(Dashboard)
